import React, { forwardRef } from 'react';
import { useRefresh } from 'react-admin';

import { DialogoProduto2 } from '../../Components';

const Container = forwardRef((props, ref) => {
  const refresh = useRefresh();
  function handleClose() {
    refresh();
  }
  return <DialogoProduto2 ref={ref} handleClose={handleClose} />;
});

export default Container;
